import { render, staticRenderFns } from "./vistaexamen.vue?vue&type=template&id=36b8acd2&"
import script from "./vistaexamen.vue?vue&type=script&lang=js&"
export * from "./vistaexamen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports